<template>
  <div class="card">
    <div class="pb-0 card-header mb-0">
      <h6>{{ title }}</h6>
      <p class="text-sm">
        <!-- <i class="fa fa-arrow-up text-success"></i> -->
        <span class="font-weight-bold">{{detail1}}</span>
        {{detail2}}
      </p>
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas id="chart-line" class="chart-canvas" height="300"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "gradient-line-chart",

  props: {
    title: {
      type: String,
      default: "Sales overview",
    },
    detail1: {
      type: String,
      default: "4% more",
    },
    detail2: {
      type: String,
      default: "",
    },
    dataChart:{
      type:Object,
      default:null
    }
  },
  mounted() {
    console.log(this.dataChart)
    var ctx1 = document.getElementById("chart-line").getContext("2d");

    new Chart(ctx1, {
      type: "bar",
      data: {
        datasets: [{
          data:this.dataChart,
          backgroundColor:'#b4243a'
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false,
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: 'id',
          yAxisKey: 'nested'
        }
      },
    });
  },
};
</script>
